"use client";

import React from "react";
import { SnackbarProvider } from "notistack";

export default function SnackbarWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={3000}>
      {children}
    </SnackbarProvider>
  );
}
